import { defineMessages } from 'react-intl';

export default defineMessages({
    pageHeaderTitle: {
        id: 'fnol.adac.confirmation-page.ADAC Ambulance service',
        defaultMessage: 'ADAC ambulance service'
    }
});
